<template>
    <setup_content v-if="active_step == 'profitable_step1_1_1'" title="Потенциальный валовой доход для объектов оценки (руб./год)">

        <template v-slot:buttons>
            <div v-if="!not_editable" class="d-flex justify-content-center mb-2" style="gap: .625rem;">
				<!--
				<b-button v-if="check_roles([ 'model' ])" variant="outline-primary-secondary" v-on:click="() => $emit('update_counts')">
                    <span>Проверка заполненности</span><base-icon name="refresh" size="md" />
                </b-button>
				-->

                <b-button v-if="!!(objects_count - data.objects_count)"
                    variant="outline-primary-secondary"
                    @click="() => $emit('set_active_step', 'profitable_step1_1_1_1')"
                >
                    <span>Настроить расчет</span><base-icon name="settings" size="md" />
                </b-button>
            </div>
        </template>

        <statistic :total="objects_count" :stats="[['', data.objects_count]]" :warning="!!(objects_count - data.objects_count)">
            <template v-slot:warning>
                <div style="line-height: 1.5rem;">
                    У части объектов оценки характеристика не заполнена.<br>
                    <!-- Дозаполните недостающие значения и проведите проверку снова или <i>настройте расчет потенциального валового дохода для объектов оценки</i> -->
                </div>
            </template>
        </statistic>

        <setup_frame v-if="not_editable" title="Настройки расчета">
            <biTable :data="rows">
                <template v-slot:value_params="row">
					<template v-if="row.data.title == 'Настройки подбора объектов-аналогов'">
						<div v-for="(value, index) in row.data.value" :key="index">{{ value }}</div>
					</template>
				</template>
            </biTable>
            <element_row v-if="data.type === type_options[0]" :title="`Арендная плата (руб./${has_oks ? 'ед. изм.' : 'кв.&nbsp;м'} в год)`" :data="data.custom_rent" readonly not_required />
        </setup_frame>

        <setup_frame v-if="not_editable && has_oks && data.type === type_options[1] && data.analogues.with_season_factors" title="Настройки сезонности объектов оценки">
            <div class="element-row">
                <label class="element-row_label"><span>Период</span></label>
                <div class="element-row_fields">
                    <v-select class="w-100" :options="period_options" :clearable="false" :value="data.analogues.season_factor.period" disabled />
                </div>
            </div>
            <element_row title="Количество периодов в высоком сезоне" :data="data.analogues.season_factor.high_season_count" readonly />
            <element_row title="Количество периодов в низком сезоне" :data="data.analogues.season_factor.low_season_count" readonly />
            <element_row title="Количество периодов в среднем сезоне" :data="data.analogues.season_factor.mid_season_count" readonly />
        </setup_frame>

    </setup_content>

    <!-- Настройка расчета Потенциального валового дохода -->

    <setup_content v-else-if="active_step == 'profitable_step1_1_1_1'" title="Настройка расчета потенциального валового дохода для объектов оценки (руб./год)">
        <div v-if="has_oks" class="element-row">
            <label class="element-row_label"><span><strong>Выбор характеристики</strong></span></label>
            <div class="element-row_fields">
                <v-select class="element-row_field" :options="attrs" :value="data.attr"
					:reduce="obj => obj.value"
                    @input="(value) => set_value('attr', value)"
                    :disabled="!check_roles([ 'model' ])"
                    :clearable="false"
                required />
            </div>
        </div>

        <div class="element-row mb-3">
            <label class="element-row_label"><span>Способ расчета арендной платы (руб./<span v-if="has_oks">ед. изм.</span><span v-else>кв.&nbsp;м</span> в год)</span></label>
            <div class="element-row_fields">
                <b-form-radio-group stacked
                    :options="type_options"
                    :checked="data.type" @change="(value) => set_value('type', value)"
                    :disabled="!check_roles([ 'model' ])"
                />
            </div>
        </div>

        <element_row v-if="data.type == 'Данные Пользователя'"
            :title="`Арендная плата (руб./${has_oks ? 'ед. изм.' : 'кв.&nbsp;м'} в год)`" :data="data.custom_rent"
            :validation="fields['custom_rent']" v-on:set_value="(key, value) => set_value(`custom_rent.${key}`, value)"
            :readonly="!check_roles([ 'model' ])"
        />
    </setup_content>

    <analogues v-else-if="active_step == 'profitable_step1_1_1_2'" :id="id" :data="data.analogues" :attr="data.attr"
		:group_id="group_id"
		v-on:set_value="(key, value) => set_value('analogues.' + key, value)"
		v-on:need_refresh="() => $emit('need_refresh')"
        :has_oks="has_oks"
    />

    <setup_content v-else-if="active_step == 'profitable_step1_1_1_3'" title="Учет фактора сезонности">
        <div class="element-row">
            <label class="element-row_label"><span>Период</span></label>
            <div class="element-row_fields">
                <v-select class="element-row_field" :options="period_options" :clearable="false"
                    :value="data.analogues.season_factor.period" @input="(value) => set_value('analogues.season_factor.period', value)"
                    :disabled="!check_roles([ 'model' ])" required
                />
            </div>
        </div>

        <element_row
            title="Количество периодов в высоком сезоне" :data="data.analogues.season_factor.high_season_count"
            :validation="fields['analogues.season_factor.high_season_count.value']" v-on:set_value="(key, value) => set_value(`analogues.season_factor.high_season_count.${key}`, value)"
            :readonly="!check_roles([ 'model' ])"
        />

        <element_row
            title="Количество периодов в низком сезоне" :data="data.analogues.season_factor.low_season_count"
            :validation="fields['analogues.season_factor.low_season_count.value']" v-on:set_value="(key, value) => set_value(`analogues.season_factor.low_season_count.${key}`, value)"
            :readonly="!check_roles([ 'model' ])"
        />

        <element_row
            title="Количество периодов в среднем сезоне" :data="data.analogues.season_factor.mid_season_count"
            :validation="fields['analogues.season_factor.mid_season_count.value']" v-on:set_value="(key, value) => set_value(`analogues.season_factor.mid_season_count.${key}`, value)"
            :readonly="!check_roles([ 'model' ])"
        />
    </setup_content>
</template>

<script>
import setup_content from "../../../setup_assets/content"
import statistic from "../../../setup_assets/statistic"
import analogues from "./analogues"
import api from "../../../../../../../api"
import element_row from "../../../../../../widgets/element-row"
import biTable from "../../../../../../widgets/bi-table"
import setup_frame from "../../../setup_assets/frame"
import variables from "../../../../../../../api/variables"

export default {
    props :
	{
		id : String,
        capitalization_data : Object,
		data : Object,
		group_id : String,
        objects_count : Number,
        active_step : String,
		not_editable : Boolean
	},

	components :
	{
        setup_content,
        // setup_frame,
        statistic,
        analogues,
        element_row,
        setup_frame,
        biTable
	},

    data()
    {
        var attrs = []

		if( api.has_oks() )
			attrs.push({ value : 'Площадь, м2', label : 'Площадь, кв.м' })
		else
			attrs.push({ value : 'Площадь, м2', label : 'Площадь, м2' })

		attrs = [ ...attrs, ...[ { value : 'Полезная (арендопригодная) площадь, м2', label : 'Полезная (арендопригодная) площадь, м2' }, { value : 'Объем, м3', label : 'Объем, м3' }, { value : 'Койко-место, шт.', label : 'Койко-место, шт.' }, { value : 'Номер, шт.', label : 'Номер, шт.' } ] ]

        return {
			attrs : attrs,
            type_options : ['Данные Пользователя', 'Рассчитать на данных об объектах-аналогах'],
            period_options : Object.values(variables.periods.types).map(({ simple }) => simple),
            fields: {
                "custom_rent":
                {
                    check: (value) => api.check_number({ value, accuracy : 2, gte : 0 }),
                    msg: "Больше или равно 0, до 2-х знаков после запятой"
                },
                "analogues.season_factor.high_season_count.value":
                {
                    check: (value) => this.check_period_count(
                        value,
                        "analogues.season_factor.high_season_count.value"
                    ),
                    msg: null
                    
                },
                "analogues.season_factor.low_season_count.value":
                {
                    check: (value) => this.check_period_count(
                        value,
                        "analogues.season_factor.low_season_count.value"
                    ),
                    msg: null
                },
                "analogues.season_factor.mid_season_count.value":
                {
                    check: (value) => this.check_period_count(
                        value,
                        "analogues.season_factor.mid_season_count.value"
                    ),
                    msg: null
                }
            }
        }
    },

    computed :
    {
        rows()
        {
            if (this.not_editable)
            {
                const result = [
                    { title : "Характеристика", value : this.data.attr },
                    { title : "Тип расчета", value : this.data.type }
                ]
    
                if (this.data.type === this.type_options[1] && this.has_oks)
                {
                    result.push({
                        title : "Арендная плата (руб./ед. изм. в год)",
                        value : this.capitalization_data.rent_price_average.all
                    })

                    const filtered = Object.entries(this.data.analogues.filter).filter((cond) => cond[1].state)
    
                    if (filtered.length !== 0)
                    {
                        result.push({
                            title : "Настройки подбора объектов-аналогов",
                            value : filtered.map(([ key, { period_count } ]) => `${variables.periods.types[key].label}: ${period_count}`),
                            params : true
                        })
                    }
                    else
                    {
                        result.push({ title : "Настройки подбора объектов-аналогов", value : "Отсутствуют" })
                    }

                    result.push({ title : "С учетом сезонности", value : this.data.analogues.with_season_factors })
                }
    
                return result
            }
            else
            {
                return []
            }
		},

		has_oks()
		{
			return api.has_oks()
		},
    },

    watch :
    {
        data :
        {
            handler(newData)
            {
                const current_period_max = variables.periods.getBySimple(newData.analogues.season_factor.period).max
                ;[
                    "analogues.season_factor.high_season_count.value",
                    "analogues.season_factor.low_season_count.value",
                    "analogues.season_factor.mid_season_count.value"
                ].forEach((key) => {
                    this.fields[key].msg = `Сумма периодов по всем сезонам не более ${current_period_max}`
                })
            },
            immediate: true
        }
    },

    methods :
    {
        check_roles(roles)
        {
            return api.check_roles(this, roles)
        },

        check_period_count(value, field)
        {
            const max = variables.periods.getBySimple(this.data.analogues.season_factor.period).max

            const fields = [
                "analogues.season_factor.high_season_count.value",
                "analogues.season_factor.low_season_count.value",
                "analogues.season_factor.mid_season_count.value"
            ]

            fields.splice(fields.indexOf(field), 1)

            const lte = max - fields.reduce((sum, key) => sum + api.get_obj_value(this.data, key), 0)

            return api.check_number({
                value,
                accuracy : 0,
                gte : 0,
                lte
            })
        },

        set_value(field, value)
        {
            if (this.fields[field])
            {
                
                if (this.fields[field].check(value))
                {
                    this.$emit('set_value', field, Number(value))
                    this.fields[field].state = null
                }
                else
                {
                    this.fields[field].state = false
                }
            }
            else if (field === 'analogues.season_factor.period')
            {
                const empty_count = { value : 0, source : "" }

                this.$emit(
                    'set_value',
                    'analogues.season_factor',
                    {
                        period : value,
                        high_season_count : empty_count,
                        low_season_count : empty_count,
                        mid_season_count : empty_count,
                    }
                )
            }
            else
            {
                this.$emit('set_value', field, value)
            }
        }
    }
}
</script>
